export default __webpack_public_path__ + "static/right_bg-8a0131f4a59738ae71c09893b55d9e60.svg";